<template>
  <main-layout class="batch-print" page-title="打印记录">
    <div slot="main-content" class="main-content">
      <div class="page">
        <div class="page-header">
          <el-date-picker
            v-model="queryParams.dateArry"
            size="medium"
            type="daterange"
            clearable
            :picker-options="pickerDateOptions"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="操作开始"
            end-placeholder="操作结束"
            @change="handleChange"
          >
          </el-date-picker>
          <el-select
            v-model="queryParams.taskTypes"
            size="medium"
            @change="handleChange"
          >
            <el-option label="全部合打印方式" :value="null"></el-option>
            <el-option
              v-for="item in printTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-input
            type="number"
            v-model.trim="queryParams.taskBatchId"
            size="medium"
            placeholder="搜索批次号"
            prefix-icon="el-icon-search"
            @input="handleChangeDebounce"
          />
        </div>
        <el-table
          v-if="!isShowEmpty"
          ref="multipleTable"
          class="page-table"
          empty-text=" "
          v-loading="tableLoading"
          :data="certificateList"
          stripe
          height="calc(100vh - 270px)"
          :row-class-name="TableRow"
          :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
          :cell-style="{ color: '#666666' }"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox
                :disabled="
                  scope.row.taskStatus === 0 && scope.row.taskType === 2
                "
                v-model="scope.row.check"
                @change="checkbogChange($event, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="打印方式" prop="taskType">
            <template slot-scope="scope">
              {{ scope.row.taskType === 1 ? "本地打印" : "远程打印" }}
            </template>
          </el-table-column>
          <el-table-column label="当前列队号" prop="queueNo">
            <template slot-scope="scope">
              {{ scope.row.taskType === 1 ? "--" : scope.row.queueNo }}
            </template>
          </el-table-column>
          <el-table-column label="批次号" prop="taskBatchId" />
          <el-table-column label="当前进度" prop="farmName">
            <template slot-scope="scope">
              {{
                scope.row.taskType === 1
                  ? "--"
                  : scope.row.finishTaskNum + "/" + scope.row.totalTaskNum
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作时间" prop="createTime" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="checkInfo(scope.row)"
                >详情</el-button
              >
              <el-button
                type="text"
                disabled
                v-if="scope.row.taskStatus === 0 && scope.row.taskType === 2"
              >
                生成中
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="noDataImg" v-else>
          <div class="imgNo">
            <img
              src="@/assets/images/aviatFarmingList/batch-nodata.png"
              alt=""
            />
          </div>
          <p style="color: #333; margin-bottom: 20px">未搜索到相关批次</p>
        </div>
        <el-pagination
          v-if="!isShowEmpty"
          :total="total"
          background
          :current-page="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @current-change="currentChange"
          @size-change="sizePageChange"
          layout="sizes, total, prev, pager, next"
          :page-sizes="[10, 50, 100, 200, 500, 1000]"
        />
      </div>
      <div class="fixed-bottom">
        <div></div>
        <div>
          <el-button
            size="medium"
            type="primary"
            round
            :disabled="!selectCertificateLength"
            @click="printCertificate(2)"
            >远程补打</el-button
          >
          <el-button
            size="medium"
            type="primary"
            round
            :disabled="!selectCertificateLength"
            @click="printCertificate(1)"
            >本地补打</el-button
          >
        </div>
      </div>
      <el-dialog
        title="多分组打印中"
        class="print-dialog"
        center
        width="790px"
        :visible.sync="printDialogVisible"
      >
        <div class="list-box">
          <div class="list-item" v-for="(item, idx) in printList" :key="idx">
            <div>
              <div class="groupName">分组{{ idx + 1 }}</div>
              <div class="desc" v-if="idx !== printList.length - 1">
                打印第{{ idx * space + 1 }}~{{ idx * space + space }}张
              </div>
              <div
                class="desc"
                v-else-if="printDetailList.length !== idx * space + 1"
              >
                打印第{{ idx * space + 1 }}~{{ printDetailList.length }}张
              </div>
              <div class="desc" v-else>
                打印第{{ printDetailList.length }}张
              </div>
            </div>
            <div class="right-btn">
              <div
                v-if="item.isPrint"
                class="againPrint"
                @click="printFun(idx)"
              >
                再次打印
              </div>
              <div
                class="printBtn"
                :class="[item.isPrint && 'disabled']"
                @click="printFun(idx)"
              >
                打印
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import {
  getPageTaskList,
  getCertificateDetailList,
  getCertificateInfoByTask,
  getCertificateStationList,
  generateTaskList,
  generatePrintRecordList,
  getPageTaskDetail,
  getFarmInfo,
} from "@/api/request/snkd.produce";
// import sameIn from "@/mixins/listsdetails";
import { debounce } from "@/utils";
import { mapActions } from "vuex";
import { Loading } from "element-ui";
import { getStorage, setStorage } from "@/utils/storage";

export default {
  name: "batchPrint",
  // mixins: [sameIn],
  components: {
    MainLayout,
  },
  data() {
    return {
      printTypeList: [
        {
          value: 1,
          label: "本地打印",
        },
        {
          value: 2,
          label: "远程打印",
        },
      ],
      certificateList: [],
      queryParams: {
        pageNo: 1,
        pageSize: 100,
        taskBatchId: "",
        taskTypes: null,
        dateArry: [],
      },
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      total: 0,
      tableLoading: false,
      isPrint: false,
      printDialogVisible: false,
      printList: [],
      space: 100,
      printDetailList: [],
      isShowEmpty: false,
      select: null,
    };
  },
  computed: {
    selectCertificateLength() {
      return this.select;
    },
  },
  created() {
    this.getFarmInfoFun();
    this.getList();
    this.isPrint = this.hasPermission("produce:certificate:print");
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    getFarmInfoFun() {
      const { companyId, farmId } = getStorage("FARMINFO");
      getFarmInfo({
        companyId,
        farmId,
      }).then((res) => {
        if (res.respCode === 0) {
          setStorage("FARMINFO", res.obj.farmDetailVO);
        }
      });
    },
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.queryParams,
        taskTypes: [this.queryParams.taskTypes],
      };
      if (this.queryParams.dateArry) {
        params["startDate"] = this.queryParams.dateArry[0] || "";
        params["endDate"] = this.queryParams.dateArry[1] || "";
      }
      getPageTaskList(params).then(({ obj }) => {
        const arr = obj ? obj.list : [];
        this.certificateList = arr.map((item) => {
          return {
            ...item,
            check: false,
          };
        });
        this.tableLoading = false;
        this.total = obj.totalCount;
        this.isShowEmpty = !this.certificateList.length;
      });
    },
    //设置表格行的样式
    TableRow({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "statistics-warning-row";
      } else {
        return "";
      }
    },
    // 输入框input 防抖
    handleChangeDebounce: debounce(async function () {
      this.queryParams.pageNo = 1;
      await this.getList();
    }),
    // 选择日期类型 chang方法
    handleChange() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    // 详情按钮
    checkInfo(item) {
      this.$router.push({
        path: "/Certificate/printRecordDetail",
        query: {
          ...item,
        },
      });
    },
    // 补打印
    async printCertificate(printType) {
      const loading = Loading.service({
        lock: true,
        text: "数据请求中…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let stationInfo;
      if (printType === 2) {
        stationInfo = await this.getRemoteStation();
        if (!stationInfo.stationId) {
          this.$message.warning("暂未关联站点，请在神农口袋APP端扫码关联");
          return;
        }
      }
      const { taskBatchId } = this.select;
      const response = await getPageTaskDetail({
        taskBatchId,
        pageSize: 10000,
      });
      const { obj } = await generateTaskList({
        certificateNos: response.obj.list.map((i) => i.certificateNo),
      });
      const params = {
        stationId: 0,
        taskBatchId: obj,
        taskPrintInfoDTO: {
          totalNum: response.obj.list.length,
          totalWeight: 0,
        },
        taskType: printType,
      };
      if (printType === 2) {
        params.stationId = stationInfo.stationId;
        await generatePrintRecordList(params);
        this.$router.push({
          path: "/operateCompleted?from=remote",
        });
        loading.close();
        return false;
      }
      await generatePrintRecordList(params);
      const resp = await getCertificateInfoByTask({
        taskBatchId: obj,
        pageSize: 10000,
      });
      const certificateIds = resp.obj.list.map((i) => i.certificateId);
      this.grounpPrint(certificateIds);
      loading.close();
    },
    async grounpPrint(certificateIds) {
      if (certificateIds.length > this.space) {
        this.printDetailList = certificateIds;
        const list = [];
        const arrLength = Math.ceil(certificateIds.length / this.space);
        for (let i = 0; i < arrLength; i++) {
          list.push({ isPrint: false });
        }
        this.printList = list;
        this.printDialogVisible = true;
      } else {
        const res = await getCertificateDetailList({ certificateIds });
        this.$print({
          list: res.obj,
        });
      }
      this.getList();
    },
    async printFun(idx) {
      this.printList[idx].isPrint = true;
      const certificateIds = this.printDetailList.slice(
        idx * this.space,
        idx * this.space + this.space
      );
      const res = await getCertificateDetailList({ certificateIds });
      this.$print({
        list: res.obj,
      });
    },
    // 页码单选
    currentChange(page) {
      this.queryParams.pageNo = page;
      this.getList();
    },
    // 分页数量
    sizePageChange(pages) {
      this.queryParams.pageNo = 1;
      this.queryParams.pageSize = pages;
      this.getList();
    },
    // 单选
    checkbogChange(val, item) {
      if (val) {
        this.certificateList = this.certificateList.map((i) => {
          const obj = {
            ...i,
            check: false,
          };
          if (i.taskBatchId === item.taskBatchId) {
            obj.check = true;
            this.select = item;
          }
          return obj;
        });
      }
    },
    async getRemoteStation() {
      const { obj } = await getCertificateStationList({});
      let remoteStation = {};
      if (obj && obj.length) {
        remoteStation = obj.filter((i) => i.defaultChoose)[0];
      }
      return remoteStation;
    },
  },
};
</script>

<style scoped lang="scss">
.batch-print {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .page {
      min-height: 0;
      flex: 1;
      padding: 20px;
      &-header {
        display: flex;
        & > div {
          width: 190px;
          margin-right: 10px;
        }
        .right-btn {
          margin-left: auto;
          margin-right: 0;
          width: auto;
        }
        ::v-deep .el-date-editor--daterange {
          width: 250px;
        }
        ::v-deep input::-webkit-outer-spin-button,
        ::v-deep input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
        }
        ::v-deep input[type="number"] {
          -moz-appearance: textfield;
        }
      }
      &-table {
        margin-top: 10px;
        ::v-deep .hidden-label {
          opacity: 0;
        }
        .produce-box {
          display: flex;
          align-items: center;
          .produceImg {
            width: 35px;
            height: 35px;
            margin-right: 10px;
          }
        }
        ::v-deep .el-checkbox__inner {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          &::after {
            width: 4.5px;
            height: 10.5px;
            top: 1.5px;
            left: 6px;
            border-width: 1.5px;
          }
          &::before {
            height: 3px;
            top: 8.5px;
          }
        }
      }
      ::v-deep .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      ::v-deep .el-table td,
      ::v-deep .el-table th.is-leaf {
        border: none;
      }
    }
    .fixed-bottom {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      padding: 18px 30px;
      box-sizing: border-box;
      box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.04);
      z-index: 1;
      .select-box {
        cursor: pointer;
        outline: 0;
        line-height: 1;
        vertical-align: middle;
        display: flex;
        align-items: center;
        &.is-indeterminate {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::before {
              content: "";
              position: absolute;
              display: block;
              background-color: #fff;
              height: 3px;
              transform: scale(0.5);
              left: 0;
              right: 0;
              top: 8.5px;
            }
          }
        }
        &.is-select {
          .selectAll {
            background-color: #64c3a4;
            border-color: #64c3a4;
            &::after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
        .selectAll {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          display: inline-block;
          position: relative;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          background-color: #fff;
          z-index: 1;
          margin-right: 10px;
          transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
            background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
          &::after {
            box-sizing: content-box;
            content: "";
            border: 1.5px solid #ffffff;
            border-left: 0;
            border-top: 0;
            height: 10.5px;
            left: 6px;
            position: absolute;
            top: 1.5px;
            transform: rotate(45deg) scaleY(0);
            width: 4.5px;
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }
      }
    }
  }
}
.print-dialog {
  ::v-deep .el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #64c3a4;
      color: #fff;
      padding: 15px 20px;
      .el-dialog__title,
      .el-dialog__close {
        color: #fff;
      }
    }
    .el-dialog__body {
      padding: 0;
      max-height: 500px;
      overflow-y: auto;
    }
  }
  .list-box {
    padding: 24px;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0px 5px 20px 0px rgba(85, 85, 124, 0.13);
    margin-bottom: 20px;
    padding: 15px 24px;
    box-sizing: border-box;
  }
  .groupName {
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .desc {
    color: #b2b2b2;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 12px;
  }
  .right-btn {
    display: flex;
    align-items: center;
  }
  .printBtn {
    width: 68px;
    height: 32px;
    line-height: 32px;
    flex-shrink: 0;
    border-radius: 30px;
    border: 1px solid #64c3a4;
    background: #eefff9;
    color: #64c3a4;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin-left: 16px;
    cursor: pointer;
  }
  .printBtn.disabled {
    border-color: #d9d9d9;
    color: #d9d9d9;
    background: #fff;
    pointer-events: none;
  }
  .againPrint {
    color: #64c3a4;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }
}
</style>
